<div class="flex flex-col items-center p-3">
  <mat-form-field class="w-full">
    <textarea matInput [formControl]="jsonFc" rows="10" class="w-full"></textarea>
  </mat-form-field>
  <button mat-flat-button color="primary" (click)="getQrCode()">Get QR Code</button>

  <pre class="py-3">
    <code>{{qrText$$ | async}}</code>
  </pre>
  <div class="flex flex-col items-center justify-center" style="width: 300px; height: 300px" #qrContainer></div>
</div>
